import React from "react";
import styles from "../../assets/styles/loan.module.css";
import { Box } from "@mui/material";
import AppIcons from "../../utils/appIcons";
import Strings from "../../utils/stringUtil";
import { isMobile } from "../../utils/responsiveUtil";

function LoanForWomenCard() {
  return (
    <Box className={`container`}>
      <Box
        className={styles.flexContainer}
        style={{ transform: isMobile ? "scale(1)" : "scale(0.92)" }}
        pt="50px"
      >
        {/* yellow card */}
        <Box
          className={styles.yellowCard}
          py={isMobile ? "6px" : "20px"}
          px={isMobile ? "15px" : "68px"}
          position={"relative"}
        >
          {/* title section */}
          <p className={styles.yellowCardTitle}>{Strings.loanForWomenTitle}</p>

          {/* description section */}
          <p className={styles.yellowCardDesc} style={{ marginTop: "6px" }}>
            {Strings.loanForWomenDesc1}
          </p>
          <p className={styles.yellowCardDesc} style={{ marginTop: "-6px" }}>
            {Strings.loanForWomenDesc2}
          </p>

          <p className={styles.yellowCardDesc} style={{ marginTop: "-12px" }}>
            {Strings.itsYourBusiness}
          </p>
          {/* blue star */}
          {!isMobile && (
            <img
              src={AppIcons.imgBlueStar}
              width={44}
              className={styles.blueStar}
              alt="blue-star"
            />
          )}
          {/* orange star */}
          {!isMobile && (
            <img
              src={AppIcons.imgOrangeStar}
              width={49}
              className={styles.orangeStar}
              alt="orange-star"
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default LoanForWomenCard;
